import { MenuItem } from "@theguarantors/ui-kit-v2/dist/layout/Header/Header.types"
import { MenuItem as MenuItemV2 } from "@theguarantors/ui-kit-v2/dist/layout/HeaderV2/Headerv2.types"
import config from "../config"

export const defaultMenuItems: MenuItem[] = [
  { label: "FAQ", url: config.faqPath },
  { label: "My Account", url: config.signinPath },
]

export const menuItemsForNoApartment: MenuItemV2[] = [
  { label: "FAQ", url: config.faqPath, position: "rightMenu", type: "link" },
  { label: "My Account", url: config.signinPath, position: "rightMenu", type: "link" },
]

export const defaultMenuItemsV2: MenuItemV2[] = [
  { label: "Renters", position: "leftMenu", type: "link", url: config.renterPath },
  { label: "Owners & Operators", position: "leftMenu", type: "link", url: config.operatorsPath },
  { label: "Sign In", position: "rightMenu", type: "link", url: config.signinPath },
  { label: "Get Started", position: "rightMenu", type: "button", url: config.getStartedPath },
]
